import React from 'react';
import { useNavigate, useParams } from 'react-router-dom'; 
import { useEffect } from 'react';
import { IconDots, IconRefresh, IconEdit, IconTrash, IconBook, IconPencil } from "@tabler/icons-react";
import { MantineMenu, MantineMenuDropdown, MantineMenuItem, MantineMenuTarget } from "../../../components/mantine/menu";
import { ActionIcon, rem } from '@mantine/core';

const ActionMenu = (props: any) => {
    const { open, item, SetSelectedRows, OpendeletePopUp } = props;
    const navigate = useNavigate();
    const siteId = item?.siteId;

    const handleNavigation = (type:any) => {
        navigate(`/managesites/${type}/${siteId}`);
    };
    return (
        <MantineMenu transitionProps={{ transition: 'pop' }} withArrow position="bottom-end" withinPortal>
            <MantineMenuTarget>
                <ActionIcon variant="subtle" color="gray">
                    <IconDots style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                </ActionIcon>
            </MantineMenuTarget>
            <MantineMenuDropdown>
                <MantineMenuItem
                    leftSection={<IconBook style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={() => { handleNavigation('manual'); SetSelectedRows(item); }}
                >
                    Manual
                </MantineMenuItem>
                <MantineMenuItem
                    leftSection={<IconPencil style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={() => { handleNavigation('drawing'); SetSelectedRows(item); }}
                >
                    Drawing
                </MantineMenuItem>
                <MantineMenuItem
                    leftSection={<IconRefresh style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={() =>{ handleNavigation('changeRequest'); SetSelectedRows(item); }}
                >
                    Change Request
                </MantineMenuItem>
                <MantineMenuItem
                    leftSection={<IconEdit style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={() => { open(); SetSelectedRows(item); }}

                >
                    Edit
                </MantineMenuItem>

                <MantineMenuItem
                    leftSection={<IconTrash style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                    onClick={() => { OpendeletePopUp(); SetSelectedRows(item); }}
                >
                    Delete
                </MantineMenuItem>
            </MantineMenuDropdown>
        </MantineMenu>
    );
};
export default ActionMenu;

